module.exports = __webpack_public_path__ + "static/img/Finn-O’sullivan.a35563c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Finn-O’sullivan.jpg
// module id = n7B3
// module chunks = 0